import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import StateContext from '../../../StateContext'
import FavoriteFixture from '../../Profile/FavoriteFixture'

function FixtureTemplate({fixture, fixtureId}) {

    const appState = useContext(StateContext)

    return (
        <div className="card card-body">
            <div className="row">
                <div className="col-5">
                    <div className="float-right">
                        {fixture.home_team} 
                        <img src={fixture.home_team_logo} alt={fixture.home_team} className="img-fluid rounded-circle logo-medium-square px-2" />
                    </div>
                </div>
                <div className="col-2 text-center">
                    <Link to={`/fixtures/${fixtureId}`}>
                        {fixture.home_goals}-{fixture.away_goals}
                    </Link><br />
                    <small>{fixture.status === "finished" ? "FT" : "" }</small>
                </div>
                <div className="col-5">
                    <img src={fixture.away_team_logo} alt={fixture.away_team} className="img-fluid rounded-circle logo-medium-square px-2" />
                    {fixture.away_team}
                    {appState.loggedIn && (
                        <span className="float-right"><FavoriteFixture fixture={fixture} fixtureId={fixture.id} /></span>
                    )}
                    
                </div>
            </div>
        </div>
    )

}
export default FixtureTemplate